import { SET_CURRENT_BREAKPOINT, SET_BREAKPOINTS, SET_IS_MOBILE } from './actions';

const setCurrentBreakpoint = (state, { name }) => ({
  ...state,
  current: name,
});

const setBreakpoints = (state, { breakpoints }) => ({
  ...state,
  breakpoints,
});

const setIsMobile = (state, { isMobile }) => ({
  ...state,
  isMobile,
});

const reducer = {
  [SET_CURRENT_BREAKPOINT]: setCurrentBreakpoint,
  [SET_BREAKPOINTS]: setBreakpoints,
  [SET_IS_MOBILE]: setIsMobile,
};

const initialCurrentBreakpoint = {
  current: '',
};

export default (state = initialCurrentBreakpoint, action) => (
  action.type && reducer[action.type] ? reducer[action.type](state, action) : state
);
